import { RuleObject } from 'rc-field-form/lib/interface'

const phoneValidator: RuleObject = {
  type: 'object',
}

export { phoneValidator }
